<template>
  <div class="select_popup_box">
    <van-cell is-link @click="sheetShow = true" :value="sheetValue" />
    <van-popup v-model="sheetShow" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="sheetShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: ["columns", "value"],
  data() {
    return {
      sheetShow: false,
      sheetValue: "请选择",
    };
  },
  // created() {
  //   let arr = this.columns.filter((item) => item.value === this.value);
  //   this.sheetValue = arr.length > 0 ? arr[0].text : "请选择";
  // },
  watch: {
    value: {
      handler(newV) {
        let arr = this.columns.filter((item) => item.value === newV);
        this.sheetValue = arr.length > 0 ? arr[0].text : "请选择";
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onConfirm(query) {
      this.$emit("input", query.value);
      this.$emit("change", query);
      this.sheetValue = query.text;
      this.sheetShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.select_popup_box {
  width: 100%;
  &::v-deep .van-cell__value {
    text-align: right;
  }
  &::v-deep .van-cell {
    padding: 0 !important;
    border: none !important;
    &::after {
      border: none;
    }
  }
  .pickerInput {
    width: 50%;
    height: 100%;
    line-height: 44px;
    &::v-deep .van-field__control {
      text-align: center !important;
    }
  }
}
</style>